export enum PageNameEnum{
    FrontPage = 1,
    CvBoxPage = 2,
    CustomerPublicPage = 3,
    SearchResultsPage = 4,
    AnnouncementDetails = 5,
    Favorites = 6
}